import { render } from "./JobDetail.vue?vue&type=template&id=1aa8dd49&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=1aa8dd49&scoped=true&lang=css"
import "./JobDetail.vue?vue&type=style&index=1&id=1aa8dd49&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa8dd49"]])

export default __exports__